import { DictionaryType } from '../types';
import { getEntriesByType } from './db';

/**
 * Trích xuất toàn bộ dữ liệu từ IndexedDB theo type và kích hoạt tải file .txt UTF-8 về thiết bị
 */
export async function exportDictionaryToFile(type: DictionaryType): Promise<void> {
  const entries = await getEntriesByType(type, 0, 1000000);
  if (entries.length === 0) {
    throw new Error(`Từ điển ${type} hiện chưa có dữ liệu để xuất.`);
  }

  // Format từng dòng: Từ gốc = Nghĩa 1 | Nghĩa 2
  const lines: string[] = [];
  for (let i = 0; i < entries.length; i++) {
    const item = entries[i];
    const meaningsStr = item.meanings.join(' | ');
    lines.push(`${item.key} = ${meaningsStr}`);
  }

  const content = lines.join('\r\n');
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${type}.txt`;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
